var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-mobile-menu"},[_c('div',{staticClass:"tabs-mobile-menu-header"},_vm._l((_vm.items),function(ref,index){
var label = ref.label;
var id = ref.id;
var count = ref.count;
var badge = ref.badge;
return _c('div',{key:index,class:{'tabs-mobile-menu-header-item': true, 'active-tab': _vm.active === id},on:{"click":function($event){return _vm.setActive(id)}}},[_vm._v("\n      "+_vm._s(label)+"\n      "),(count)?_c('BadgeCounter',{staticClass:"ml-1",attrs:{"count":count,"color":badge}}):_vm._e()],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02da88d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/TabsMenuMobile.vue
// module id = null
// module chunks = 